import { Box } from '@chakra-ui/react';
import React from 'react';

const IconBackground = (props: {
  colour: string;
  children: React.ReactNode;
}) => (
  <Box
    mr="6"
    backgroundColor={props.colour}
    borderRadius="lg"
    height={7}
    width={7}
    display="flex"
    justifyContent="center"
    alignItems="center"
    flexShrink={0}
  >
    {props.children}
  </Box>
);

export default IconBackground;
